import React from 'react';
import SyncOnlyContacts from './onlyContacts/syncOnlyContacts';

const LeadSyncSettingsSalesforceInbound = props => <SyncOnlyContacts {...props} />;

export default LeadSyncSettingsSalesforceInbound;
